// extracted by mini-css-extract-plugin
export default {"infoTooltip":"AVvwY","tooltip":"uuTmu","tooltipRight":"ulrv5","small":"_iPi5"};